//
//
//
//
//
export default {
  props: {
    title: {
      type: String,
      default: 'タイトル'
    },
    classes: {
      type: String,
      default: 'is-2'
    }
  }
};